import { render, staticRenderFns } from "./ReportsTabContent.vue?vue&type=template&id=0e84c395&"
import script from "./ReportsTabContent.vue?vue&type=script&lang=ts&"
export * from "./ReportsTabContent.vue?vue&type=script&lang=ts&"
import style0 from "./ReportsTabContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports